import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
const initialState = {
    status: 'init'
};
export const updateCryptoConnect = createAsyncThunk('crypto/connect', async (credentials, thunkApi) => {
    try {
        return await (await api.instance).cryptoConnect(Object.assign(Object.assign({}, credentials), { disconnect: false }));
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const updateCryptoDisconnect = createAsyncThunk('crypto/disconnect', async (credentials, thunkApi) => {
    try {
        return await (await api.instance).cryptoConnect(Object.assign(Object.assign({}, credentials), { disconnect: true }));
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export function isCryptoConnectFulfilledAction(action) {
    return [updateCryptoConnect.fulfilled.type, updateCryptoDisconnect.fulfilled.type].includes(action.type);
}
function isUpdatingAction(action) {
    return [updateCryptoConnect.pending.type, updateCryptoDisconnect.pending.type].includes(action.type);
}
function isRejectedAction(action) {
    return action.type.startsWith('crypto/') && action.type.endsWith('/rejected');
}
const cryptoConnectSlice = createSlice({
    name: 'connect',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(isCryptoConnectFulfilledAction, (state) => {
            state.status = 'success';
        })
            .addMatcher(isUpdatingAction, (state) => {
            state.status = 'updating';
        })
            .addMatcher(isRejectedAction, (state, action) => {
            state.status = 'error';
            state.error = action.payload;
        });
    }
});
export const cryptoConnectReducer = cryptoConnectSlice.reducer;
